<p-dialog [(visible)]="openDialog" [modal]="true" [style]="{'top': '4vh', 'width': '80vw', 'max-width': '100rem', 'min-height': '55vh'}"
          [breakpoints]="{'1200px': '80vw','990px': '70vw','768px': '85vw','576px': '95vw'}"
          [draggable]="false" [resizable]="false" appendTo="body" class="p-fluid"
          (onHide)="closeDialog()">
    <ng-template pTemplate="header">
        <div class="inline-flex align-items-center justify-content-center gap-2">
            <i class="pi pi-tags text-blue-500 text-2xl" *ngIf="type==EvaluacionEstadosControl.Observaciones"></i>
            <span class="white-space-nowrap" *ngIf="type==EvaluacionEstadosControl.Observaciones">
                        {{titleHeader}} - SOLICITUD #{{ selected?.numeroExpediente }}
                    </span>
            <i class="pi pi-tags text-orange-500 text-2xl" *ngIf="type==EvaluacionEstadosControl.Dictamen"></i>
            <span class="white-space-nowrap" *ngIf="type==EvaluacionEstadosControl.Dictamen">
                        {{titleHeader}} - SOLICITUD #{{ selected?.numeroExpediente }}
                    </span>
        </div>
    </ng-template>
        <shared-loader *ngIf="_showLoader"></shared-loader>
    <div *ngIf="textReadOnly && infoDictamen!=null" class="flex flex-wrap justify-content-center md:justify-content-end gap-3">
        <span
            pTooltip="Fecha de creacion"
            class="inline-flex align-items-center py-2 px-3 font-medium border-1 surface-border border-round">
            <i class="pi pi-clock text-primary mr-2"></i>
            <span class="text-900">{{ this.infoDictamen?.fechaCreacion }}</span>
        </span>
        <span [style]="tagStyle(infoDictamen?.estado==1?true:false)"
              pTooltip="Estado"
              class="inline-flex align-items-center py-2 px-3 font-medium border-1 surface-border border-round">
                    <i class="pi pi-tag mr-2 text-white"></i>
                    <span class="text-white">{{infoDictamen.estado==1?'Activo':'Inactivo'}}</span>
        </span>
    </div>
    <div class="flex flex-wrap gap-3">
        <div class="flex-none field xl:w-2 lg:w-3 md:w-3 xs:w-3" *ngIf="type==EvaluacionEstadosControl.Dictamen">
            <b>
                <div class="text-900 font-semibold mb-4">Items evaluados ({{selectedItems.length}})</div>
            </b>
            <p-listbox
                [options]="evaluaciones"
                [(ngModel)]="selectedItems"
                [selectAll]="selectAll"
                optionLabel="evalNombre"
                [listStyle]="{'max-height': '400px', 'min-height': '405px', 'width': '100%'}"
                [multiple]="true"
                [metaKeySelection]="false"
                (onSelectAllChange)="onSelectAllChange($event)"
                (onChange)="onChange($event)"
                [readonly]="type==EvaluacionEstadosControl.Dictamen?true:false || textReadOnly"
                scrollHeight="250px">
                <ng-template let-item pTemplate="item">
                    <div class="flex align-items-center">
                        <p-checkbox
                            [binary]="true"
                            [ngModel]="isSelected(item)"
                            (onChange)="toggleSelection(item)">
                        </p-checkbox>
                        <span class="ml-2" [pTooltip]="item.evalNombre">{{item.evalNombre}}</span>
                    </div>
                </ng-template>
            </p-listbox>
        </div>
        <div class="flex-1 field">
            <b>
                <div class="text-900 font-semibold mb-3">Detalle opinión técnica</div>
            </b>
            <app-editor-text *ngIf="!textReadOnly" (onEventEmitterText)="onEditorText($event)" [text]="getSelectedItemNames()" [type]="type"></app-editor-text>
            <app-editor-text *ngIf="textReadOnly && EvaluacionEstadosControl.Dictamen === type" (onEventEmitterText)="onEditorText($event)" [text]="getSelectedDictamenInfo()" [textReadOnly]="textReadOnly" [type]="type"></app-editor-text>
            <app-editor-text *ngIf="textReadOnly && EvaluacionEstadosControl.Observaciones === type" (onEventEmitterText)="onEditorText($event)" [text]="getObservacioneInfo()" [textReadOnly]="textReadOnly" [type]="type"></app-editor-text>
        </div>
    </div>

    <ng-template pTemplate="footer">
        <button pButton pRipple icon="pi pi-times" class="p-button-text" label="Cerrar" (click)="closeDialog()"></button>
        <button *ngIf="!textReadOnly" pButton pRipple icon="pi pi-check" class="p-button-text"
                [label]="type==EvaluacionEstadosControl.Observaciones ? 'Notificar observaciones':'Procesar dictamen'"
                (click)="guardar()"></button>
    </ng-template>
</p-dialog>
